import template from './index.html';
import controller from './index.controller';
import './index.scss';

let indexComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default indexComponent;



// WEBPACK FOOTER //
// ./client/app/features/mainRouting/index/index.component.js